import { Injectable } from '@angular/core';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { UtilService } from '@service/util/util.service';

@Injectable({
	providedIn: 'root',
})
export class RFPService {
	constructor(
		private utilService: UtilService,
		private segmentWrapper: SegmentWrapperService
	) {}

	sendRFPSubmittedSegmentEvent(s3Key: string) {
		const eventProperties = {
			user: this.utilService.getUserDataForSegmentEvent(),
			submittedAt: new Date(),
			s3Key,
		};
		this.segmentWrapper.fireSegmentEvent(
			SegmentEventsConstants.user_submitted_rfp,
			eventProperties
		);
	}

	sendGreenscreensSettingUpdatedSegmentEvent(currentValue: boolean) {
		const eventProperties = {
			user: this.utilService.getUserDataForSegmentEvent(),
			currentValue,
			previousValue: !currentValue,
		};
		this.segmentWrapper.fireSegmentEvent(
			SegmentEventsConstants.user_updated_rfp_greenscreens_setting,
			eventProperties
		);
	}
}
